<span class="productMapper">
   <section
      class="p-2"
      *ngIf="state$ | async as state">
      <div class="d-flex flex-row mb-2">
         <div
            class="flex-column ml-2"
            style="max-width: 300px">
            <!--<span style="font-weight:600; margin-bottom:5px;">Filter by Hospital:</span>-->
            <p-select
               [filter]="true"
               [options]="practices"
               (onChange)="onPracticeSelected($event.value)"
               [ngModel]="state.selectedPractice"
               optionLabel="nameId"
               placeholder="Select a hospital"
               [class.hospitalFilterDrop]="true"
               [showClear]="true"></p-select>
         </div>
         <div
            *ngIf="siteCount > 1"
            class="flex-column ml-2 v-dropdown-sm"
            [ngStyle]="{ opacity: state.selectedPracticeSKey ? '1' : '0.3' }">
            <p-dropdown
               [filter]="true"
               placeholder="Search by Site"
               [options]="sites"
               (onChange)="onSiteChanged($event.value)"
               ngModelOptions="{standalone: true}"
               [showClear]="true"
               (onClear)="onSiteClear()"
               [class.v-sitefilter]="true"></p-dropdown>
         </div>
         <div
            class="flex-column ml-2 v-dropdown-sm"
            style="max-width: 300px"
            [ngStyle]="{ opacity: state.selectedPracticeSKey || state.selectedVCProductSKey ? '1' : '0.3' }">
            <p-dropdown
               [filter]="true"
               placeholder="Your Category"
               [options]="yourCatList"
               (onChange)="onCategoryChanged($event.value)"
               ngModelOptions="{standalone: true}"
               [showClear]="true"
               (onClear)="onCategoryClear()"
               [class.v-categoryfilter]="true"></p-dropdown>
         </div>
         <div
            class="flex-column ml-2 v-dropdown-xs"
            style="max-width: 165px"
            [ngStyle]="{ opacity: state.selectedPracticeSKey || state.selectedVCProductSKey ? '1' : '0.3' }">
            <!--<span style="font-weight:600; margin-bottom:5px;">Filter by Type:</span>-->

            <p-dropdown
               [filter]="true"
               placeholder="Type"
               [options]="productTypes"
               (onChange)="onProductTypeChanged($event.value)"
               optionLabel="productTypeName"
               ngModelOptions="{standalone: true}"
               [showClear]="true"
               (onClear)="onCategoryClear()"
               [class.v-typefilter]="true"></p-dropdown>
         </div>
         <div
            class="flex-column ml-2 v-searchbox-sm v-productfilter"
            [ngStyle]="{ opacity: state.selectedPracticeSKey || state.selectedVCProductSKey ? '1' : '0.3' }">
            <input
               pInputText
               [(ngModel)]="searchTextInput"
               (input)="onSearch()"
               ngModelOptions="{standalone: true}"
               name="searchTextInput"
               placeholder="Product Name..." />
         </div>
         <div
            class="flex-column ml-2 v-searchbox-xs v-codefilter"
            [ngStyle]="{ opacity: state.selectedPracticeSKey || state.selectedVCProductSKey ? '1' : '0.3' }">
            <input
               pInputText
               [(ngModel)]="searchCodeInput"
               (input)="onSearchCode()"
               ngModelOptions="{standalone: true}"
               name="searchCodeInput"
               placeholder="Your Code..." />
         </div>
      </div>

      <div
         *ngIf="state.selectedPracticeSKey || state.selectedVCProductSKey"
         class="ml-auto d-flex align-items-end onlyFilters"
         style="display: flex; float: right; margin-bottom: -32px; justify-content: end; padding-top: 10px">
         <p-checkbox
            [ngModel]="state.onlyActiveProducts"
            [binary]="true"
            (onChange)="setOnlyActiveProducts($event)"
            inputId="onlyActiveProducts"></p-checkbox>
         <label
            for="onlyActiveProducts"
            class="mb-0 ml-1"
            style="line-height: 16px; max-width: 70px">
            Only active products
         </label>
         <p-checkbox
            [ngModel]="state.onlyUnmappedProducts"
            [binary]="true"
            (onChange)="setOnlyUnmappedProducts($event)"
            inputId="onlyUnmappedProducts"
            styleClass="ml-3"></p-checkbox>
         <label
            for="onlyUnmappedProducts"
            class="mb-0 ml-1"
            style="line-height: 16px; max-width: 100px">
            Only unmapped products
         </label>

         <p-checkbox
            [ngModel]="state.onlyUnconfirmedProducts"
            [binary]="true"
            (onChange)="setOnlyUnconfirmedProducts($event)"
            inputId="onlyUnconfirmedProducts"
            styleClass="ml-3"></p-checkbox>
         <label
            for="onlyUnconfirmedProducts"
            class="mb-0 ml-1"
            style="line-height: 16px; max-width: 110px">
            Only unconfirmed products
         </label>

         <p-checkbox
            [ngModel]="state.onlySoldLastTTM"
            [binary]="true"
            (onChange)="setOnlyShowSoldTTM($event)"
            inputId="onlyShowSoldTTM"
            styleClass="ml-3"></p-checkbox>
         <label
            for="onlyShowSoldTTM"
            class="mb-0 ml-1"
            style="line-height: 16px; max-width: 85px">
            Only invoiced TTM
         </label>
      </div>

      <div
         class="d-flex flex-row"
         style="width: 100%">
         <!--<div class="flex-column"
             style="width: 600px">
            <p-table #dt
                     *ngIf="rows?.length > 0"
                     [value]="rows"
                     [lazy]="true"
                     [loading]="loading"
                     [scrollable]="true"
                     (onLazyLoad)="loadMore($event)">
                <ng-template pTemplate="header">
                    <tr>
                        <th style="width:100px;">ID</th>
                        <th>Name</th>
                        <th></th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body"
                             let-product>
                    <tr>
                        <td style="width:100px;">{{ product.vcProductSKey }}</td>
                        <td>{{ product.name }}</td>
                        <td>
                            <button class="btn btn-primary text-nowrap"
                                    (click)="selectProduct(product)">Select ></button>
                        </td>
                    </tr>
                </ng-template>
            </p-table>
            <div *ngIf="rows?.length === rowsToTake"
                 class="alert alert-info">Please filter to view other results.</div>
        </div>
    -->
         <div
            class="flex-column flex-grow-1 align-items-center"
            style="margin-top: 5px"
            [class.loading]="(loading$ | async) || state.loadingPIMS">
            <vc-spinner *ngIf="(loading$ | async) || state.loadingPIMS"></vc-spinner>
            <div
               class="viewport"
               *ngIf="!(loading$ | async) && !state.loadingPIMS">
               <div
                  class="alert alert-info text-center"
                  *ngIf="!state.selectedPracticeSKey">
                  Please select a hospital above.
               </div>
               <vc-product-pims-list
                  *ngIf="state.selectedPracticeSKey || state.selectedVCProductSKey"
                  [showPracticeColumn]="false"
                  [showPriceColumn]="true"
                  [rows]="state.pimsRows"
                  [vcProductsWithoutMappedPercentage]="true"
				  [siteCount]="siteCount"
                  [vcProductsWithCodes]="true"
                  [virtualScrollItemSize]="100"></vc-product-pims-list>
            </div>
         </div>
      </div>
   </section>
   <vc-products-feedback />
</span>
